import React from 'react';
import '../../styles/PatientReviews.css';
const PatientReviews = () => {
  const reviews = [
    {
      id: 1,
      comment: "Thank you timeless homecare service for your great care for my mother.",
      stars: 5,
      name: "Diveka",
      date: "January 29, 2020"
    },
    {
      id: 2,
      comment: "Its very Helpful for the elderly people.",
      stars: 5,
      name: "Aparna",
      date: "August 20, 2020"
    },
    {
      id: 3,
      comment: "I found a nurse from Timeless Home care service to take care of my grandfather. The nurse Aseela took good care of him, was very professional in her approach and the price was also reasonable. Thank you for your support.",
      stars: 5,
      name: "Meera",
      date: "August 20, 2022"
    },
    {
      id: 4,
      comment: "Timeless Homecare Service provides excellent service. The staff is friendly and caring. After solving the long waiting time issue, it's much easier now. The team is professional and punctual, making me feel safe and supported at home. Highly recommend this home care service.",
      stars: 5,
      name: "Nishanth Nisha",
      date: "Patient"
    },
    {
      id: 5,
      comment: "Timeless Homecare Service provides excellent and affordable home care services. The staff is professional and attentive to all needs. Perfect for various home care requirements. Great value for money.",
      stars: 5,
      name: "Bhuvana",
      date: "Patient"
    },
    {
      id: 14,
      comment: "Very good",
      stars: 5,
      name: "Nikita Mondal",
      date: "a year ago"
    },
    
    {
      id: 7,
      comment: "Timeless Home Care Center is a beacon of hope. The staff are healing heroes who dispel fear and anxiety with wisdom and love, restoring vitality. It's an oasis of love and care.",
      stars: 5,
      name: "It's me",
      date: "5 months ago"
    },
    {
      id: 16,
      comment: "Good work",
      stars: 5,
      name: "Deva",
      date: "a year ago"
    },
    {
      id: 8,
      comment: "Recently we have taken service from Timeless home care, the staff is very friendly, caring and reliable. Their service is very good and I highly recommend them for people those who need best home care service.",
      stars: 5,
      name: "Asha",
      date: "5 months ago"
    },
    // {
    //   id: 9,
    //   comment: "Response was timely. But the staffs need more training as they are not professional nurses in my case. They need to learn to understand a patient and serve. Conduct was good.",
    //   stars: 2,
    //   name: "Shibin David",
    //   date: "8 months ago"
    // },
    {
      id: 15,
      comment: "Service good",
      stars: 5,
      name: "Kalai Kalai",
      date: "2 weeks ago"
    },
    
    {
      id: 10,
      comment: "After consulting for my grandmother, the team immediately started home care service. The service was satisfactory and professional, with nurses taking meticulous care. Congratulations to the nursing team and hope for continued service.",
      stars: 5,
      name: "shankar narayanan",
      date: "2 years ago"
    },
    {
      id: 11,
      comment: "Had a good experience and learned new things from the service.",
      stars: 5,
      name: "Sandhya Sandhya",
      date: "a year ago"
    },
    {
      id: 12,
      comment: "Thank you for the service and I learned a lot.",
      stars: 5,
      name: "Aiswarya Aiswarya",
      date: "a year ago"
    },
    {
      id: 13,
      comment: "The nursing care was excellent and showed great compassion.",
      stars: 5,
      name: "Durga",
      date: "2 weeks ago"
    },
    
    {
      id: 17,
      comment: "Good experience Thanks",
      stars: 5,
      name: "Raji Raji",
      date: "a year ago"
    },
    {
      id: 18,
      comment: "Good service and team work thanks a lot",
      stars: 5,
      name: "Madhu Mala",
      date: "13 hours ago"
    }
  ];
  const renderStars = (count) => {
    return '★'.repeat(count) + '☆'.repeat(5 - count);
  };
  // Create a duplicated array for seamless looping
  const duplicatedReviews = [...reviews, ...reviews];
  return (
    <div className="patient-reviews-container">
      <div className="reviews-header">
        <div className="quote-icon">❝</div>
        <h2 className="reviews-title">What Our Patients Say</h2>
        <p className="reviews-subtitle">Real stories from those we've had the privilege to care for</p>
      </div>
      
      <div className="marquee-container">
        <div className="marquee">
          {duplicatedReviews.map((review, index) => (
            <div key={`${review.id}-${index}`} className="review-card">
              <p className="review-comment">{review.comment}</p>
              <div className="review-stars">{renderStars(review.stars)}</div>
              <div className="review-info">
                <div className="review-name">{review.name}</div>
                <div className="review-date">{review.date}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default PatientReviews;